/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
//import SVG from "react-inlinesvg";
import { checkIsActive } from '../../../../_helpers';

export function HeaderMenu({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? 'menu-item-active' : '';
  };

  return (
    <div
      id='kt_header_menu'
      className={`header-menu header-menu-left header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/*begin::Header Nav*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        {/*  <li className={`menu-item menu-item-rel ${getMenuItemActive('/dashboard')}`}>
                <NavLink className="menu-link" to="/dashboard">
                    <span className="menu-text">Dashboard</span>
                    {layoutProps.rootArrowEnabled && (<i className="menu-arrow" />)}
                </NavLink>
            </li> */}
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          id='ORDERS'
          data-menu-toggle={layoutProps.menuDesktopToggle}
          aria-haspopup='true'
          className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
            '/orders'
          )}`}
        >
          <NavLink className='menu-link menu-toggle' to='/orders'>
            <span className='menu-text'>
              <FormattedMessage id='HEADER.MENU.PURCHASE' />
            </span>
            <i className='menu-arrow'></i>
          </NavLink>
          <div className='menu-submenu menu-submenu-classic menu-submenu-left'>
            <ul className='menu-subnav'>
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/orders'
                )}`}
              >
                <NavLink className='menu-link' to='/orders'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.ORDER' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/boxes'
                )}`}
              >
                <NavLink className='menu-link' to='/boxes'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.BOX' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          id='PRODUCTS'
          data-menu-toggle={layoutProps.menuDesktopToggle}
          aria-haspopup='true'
          className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
            '/products'
          )}`}
        >
          <NavLink className='menu-link menu-toggle' to='/products'>
            <span className='menu-text'>
              <FormattedMessage id='HEADER.MENU.WAREHOUSE' />
            </span>
            <i className='menu-arrow' />
          </NavLink>
          <div className='menu-submenu menu-submenu-classic menu-submenu-left'>
            <ul className='menu-subnav'>
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/products'
                )}`}
              >
                <NavLink className='menu-link' to='/products'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.PRODUCT' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/stocks'
                )}`}
              >
                <NavLink className='menu-link' to='/stocks'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.STOCK' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          id='SALES'
          data-menu-toggle={layoutProps.menuDesktopToggle}
          aria-haspopup='true'
          className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
            '/sales'
          )}`}
        >
          <NavLink className='menu-link menu-toggle' to='/sales'>
            <span className='menu-text'>
              <FormattedMessage id='HEADER.MENU.SALE' />
            </span>
            {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
          </NavLink>
          <div className='menu-submenu menu-submenu-classic menu-submenu-left'>
            <ul className='menu-subnav'>
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/sales'
                )}`}
              >
                <NavLink className='menu-link' to='/sales'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.SALE' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/delivers'
                )}`}
              >
                <NavLink className='menu-link' to='/deliveries'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.DELIVER' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          id='FINANCE'
          data-menu-toggle={layoutProps.menuDesktopToggle}
          aria-haspopup='true'
          className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive(
            '/finance'
          )}`}
        >
          <NavLink className='menu-link menu-toggle' to='/finance'>
            <span className='menu-text'>
              <FormattedMessage id='HEADER.MENU.FINANCE' />
            </span>
            {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
          </NavLink>
          <div className='menu-submenu menu-submenu-classic menu-submenu-left'>
            <ul className='menu-subnav'>
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/financeSales'
                )}`}
              >
                <NavLink className='menu-link' to='/financeSales'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.FINANCE.SALES' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/financeOrders'
                )}`}
              >
                <NavLink className='menu-link' to='/financeOrders'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.FINANCE.ORDERS' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
              {/*begin::2 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  '/financeStocks'
                )}`}
              >
                <NavLink className='menu-link' to='/financeStocks'>
                  <span className='menu-text'>
                    <FormattedMessage id='HEADER.SUBMENU.FINANCE.STOCKS' />
                  </span>
                  {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
                </NavLink>
              </li>
              {/*end::2 Level*/}
            </ul>
          </div>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive('/users')}`}
        >
          <NavLink className='menu-link' to='/users'>
            <span className='menu-text'>
              <FormattedMessage id='HEADER.MENU.USER' />
            </span>
            {layoutProps.rootArrowEnabled && <i className='menu-arrow' />}
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        {/*  <li className={`menu-item menu-item-rel ${getMenuItemActive('/merchantconfig')}`}>
                <NavLink className="menu-link" to="/merchantconfig">
                    <span className="menu-text">Configuration</span>
                    {layoutProps.rootArrowEnabled && (<i className="menu-arrow" />)}
                </NavLink>
            </li> */}
        {/*end::1 Level*/}
      </ul>
      {/*end::Header Nav*/}
    </div>
  );
}
